import Connect from './views/Connect'

export default [{
  path: '/instagram/connect',
  name: 'instagram.connect',
  component: Connect
}]
